import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 4h-3V2h-4v2H7v18h10V4z"
}), 'BatteryFullSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BatteryFullSharp.js
// module id = 2316
// module chunks = 2